import React from "react";
import { Button, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

export const ErrorPage = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const location = useLocation();
  const { message } = location.state || {};

  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <Typography variant="h4" component="h1" id="page-heading" tabIndex={-1} color="error">An Error Occurred</Typography>
      <div role="alert" aria-live="assertive" style={{ marginTop: '1rem' }}>
        <Typography variant="body1">
          {message || queryParams.get('message') || 'An unexpected error has occurred.'}
        </Typography>
      </div>
      <Typography variant="body1" style={{ marginTop: '1rem' }}>
        We apologize for the inconvenience. Please try again later.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => window.history.back()} style={{ marginTop: '2rem' }}>
        Go Back
      </Button>
    </div>
  );
};
